import { render, staticRenderFns } from "./SelectOperatingSystemCard.vue?vue&type=template&id=0851ced6&"
import script from "./SelectOperatingSystemCard.vue?vue&type=script&lang=js&"
export * from "./SelectOperatingSystemCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports